if (!customElements.get('collection-transition-photo')) {
  customElements.define('collection-transition-photo', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-photo-slide]')];
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.busy = false;
      this.querySelector('.collection-transition-photo__controls').hidden = this.dataset.showControls === 'false';
      this.querySelector('[data-photo-toggle]').addEventListener('click', () => {
        this.paused = !this.paused;
        this.update();
      }, options);
      this.querySelector('[data-photo-next]').addEventListener('click', () => this.advance(), options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && this.dataset.pauseHover !== 'false') { this.hovered = true; this.update(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.update(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.update(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.update(); }
      }, options);
      document.addEventListener('visibilitychange', () => this.update(), options);
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.update(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.update();
    }

    update() {
      clearTimeout(this.timer);
      if (!this.isConnected) return;
      this.querySelector('[data-photo-toggle]').setAttribute('aria-label', this.paused ? 'Play photo rotation' : 'Pause photo rotation');
      this.querySelector('[data-photo-toggle-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
      if (!this.paused && this.visible && !document.hidden && !this.hovered && !this.focused && !this.busy) {
        this.timer = setTimeout(() => this.advance(), Math.max(3, Number(this.dataset.seconds) || 4) * 1000);
      }
    }

    async advance() {
      if (this.busy || !this.isConnected) return;
      clearTimeout(this.timer);
      this.busy = true;
      const connection = this.abort;
      const next = (this.index + 1) % this.slides.length;
      const photo = this.slides[next].querySelector('img');
      try {
        photo.loading = 'eager';
        await photo.decode();
        if (!this.isConnected || connection.signal.aborted) return;
        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.slides[next].classList.add('is-active');
        this.slides[next].setAttribute('aria-hidden', 'false');
        this.index = next;
        this.querySelector('[data-photo-count]').textContent = `${next + 1} / ${this.slides.length}`;
      } catch {
        // Keep the current photo visible if the next image cannot load.
      } finally {
        if (!connection.signal.aborted) { this.busy = false; this.update(); }
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
